import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { EventStreamCodec, MessageDecoderStream, MessageEncoderStream, SmithyMessageDecoderStream, SmithyMessageEncoderStream } from "@smithy/eventstream-codec";
import { getChunkedStream } from "./getChunkedStream";
import { getMessageUnmarshaller } from "./getUnmarshalledStream";
export var EventStreamMarshaller = /*#__PURE__*/function () {
  function EventStreamMarshaller(_ref) {
    var utf8Encoder = _ref.utf8Encoder,
      utf8Decoder = _ref.utf8Decoder;
    _classCallCheck(this, EventStreamMarshaller);
    this.eventStreamCodec = new EventStreamCodec(utf8Encoder, utf8Decoder);
    this.utfEncoder = utf8Encoder;
  }
  _createClass(EventStreamMarshaller, [{
    key: "deserialize",
    value: function deserialize(body, deserializer) {
      var inputStream = getChunkedStream(body);
      return new SmithyMessageDecoderStream({
        messageStream: new MessageDecoderStream({
          inputStream: inputStream,
          decoder: this.eventStreamCodec
        }),
        deserializer: getMessageUnmarshaller(deserializer, this.utfEncoder)
      });
    }
  }, {
    key: "serialize",
    value: function serialize(inputStream, serializer) {
      return new MessageEncoderStream({
        messageStream: new SmithyMessageEncoderStream({
          inputStream: inputStream,
          serializer: serializer
        }),
        encoder: this.eventStreamCodec,
        includeEndFrame: true
      });
    }
  }]);
  return EventStreamMarshaller;
}();